var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon16PxCameraOutline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 4.53846C11.5 4.31404 11.4108 4.09883 11.2522 3.94014C11.0935 3.78146 10.8782 3.69231 10.6538 3.69231H8.96154L7.69231 2H4.30769L3.03846 3.69231H1.34615C1.12174 3.69231 0.906518 3.78146 0.747833 3.94014C0.589148 4.09883 0.5 4.31404 0.5 4.53846V9.61538C0.5 9.83978 0.589148 10.055 0.747833 10.2137C0.906518 10.3724 1.12174 10.4615 1.34615 10.4615H10.6538C10.8782 10.4615 11.0935 10.3724 11.2522 10.2137C11.4108 10.055 11.5 9.83978 11.5 9.61538V4.53846Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00346 8.55769C7.05492 8.55769 7.9073 7.70531 7.9073 6.65385C7.9073 5.60238 7.05492 4.75 6.00346 4.75C4.95199 4.75 4.09961 5.60238 4.09961 6.65385C4.09961 7.70531 4.95199 8.55769 6.00346 8.55769Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon16PxCameraOutline);
export default __webpack_public_path__ + "static/media/icon_16px_camera_outline.8453878c9aaf9caee891ce954f7caaa9.svg";
export { ForwardRef as ReactComponent };